import React from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";
import {
  CheckCircle2,
  Globe2,
  Shield,
  Cpu,
  Layers,
  Rocket,
  Handshake,
} from "lucide-react";
import { COLOR_ACCENT, COLOR_PRIMARY } from "../config/Constants";

const services = [
  {
    title: "Product Engineering",
    desc: "Greenfield builds and modernizing legacy apps with maintainable, performant architectures.",
    icon: <Rocket className="w-6 h-6" />,
    bullets: [
      "MVPs to scale",
      "Monolith → microservices",
      "DX & observability",
    ],
  },
  {
    title: "Cloud & DevOps",
    desc: "Design, infra-as-code, cost optimization, SRE, and secure delivery pipelines on AWS/GCP/Azure.",
    icon: <Globe2 className="w-6 h-6" />,
    bullets: ["Kubernetes", "Terraform", "Cloud cost control"],
  },
  {
    title: "AI & Data",
    desc: "Applied AI/ML for real business outcomes: RAG, LLM apps, analytics, and MLOps.",
    icon: <Cpu className="w-6 h-6" />,
    bullets: ["LLM apps", "RAG & vectors", "MLOps"],
  },
  {
    title: "Mobile & Web",
    desc: "Delightful experiences with accessibility, performance, and strong SEO at the core.",
    icon: <Layers className="w-6 h-6" />,
    bullets: ["Next.js/React", "Flutter/React Native", "PWAs"],
  },
  {
    title: "Security by Design",
    desc: "Threat modeling, secure SDLC, audits and compliance guidance (SOC2, ISO 27001).",
    icon: <Shield className="w-6 h-6" />,
    bullets: ["AppSec reviews", "Pen-test readiness", "Compliance"],
  },
  {
    title: "Team Augmentation",
    desc: "Flexible pods and specialists across time zones for overseas and Indian clients.",
    icon: <Handshake className="w-6 h-6" />,
    bullets: ["Pods & staff aug", "Timezone overlap", "Agile delivery"],
  },
];

export const Services = () => {
  return (
    <Section
      id="services"
      eyebrow="What we do"
      title="Services"
      subtitle="Expert teams across product, cloud, data, mobile, and security to ship outcomes—not just tickets."
    >
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s) => (
          <Card key={s.title}>
            <div className="flex items-start gap-3">
              <div
                className="rounded-xl bg-indigo-50 p-2 text-indigo-700"
                style={{ color: COLOR_PRIMARY }}
              >
                {s.icon}
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">{s.title}</h3>
                <p className="mt-1 text-sm text-gray-600">{s.desc}</p>
              </div>
            </div>
            <ul className="mt-4 space-y-2 text-sm text-gray-600">
              {s.bullets.map((b) => (
                <li key={b} className="flex items-center gap-2">
                  <CheckCircle2
                    className="w-4 h-4 text-indigo-600"
                    style={{ color: COLOR_ACCENT }}
                  />{" "}
                  {b}
                </li>
              ))}
            </ul>
          </Card>
        ))}
      </div>
    </Section>
  );
};
